import { useWatch } from 'react-hook-form';
import { ArrayInput } from '../../../components/admin/array-input';
import { BooleanInput } from '../../../components/admin/boolean-input';
import { TextInput } from '../../../components/admin/text-input';
import { Button } from '../../../components/ui/button';
import { Plus } from 'lucide-react';
import {
  required,
  useSimpleFormIterator,
  useSourceContext,
  useTranslate,
} from 'ra-core';
import { MoonstarFormIteratorEntry } from '../../Moonstar/MoonstarFormIteratorEntry';
import { MoonstarFormIterator } from '../../Moonstar/MoonstarFormIterator';
import { type ChecklistTaskFormValues } from '../../../api/transformHooks/checklistDataTransform';

export function ChecklistTaskInput() {
  const sourceCtx = useSourceContext();
  const type: ChecklistTaskFormValues['type'] = useWatch({
    name: sourceCtx.getSource('type'),
  });

  return (
    <MoonstarFormIteratorEntry
      labelSource="title"
      placeholder="moonstar.checklists.tasks.placeholder"
      defaultExpanded
    >
      <TextInput source="title" validate={required()} />
      <TextInput source="description" multiline inputClassName="min-h-20" />
      {type === 'TASK' && <TaskInputs />}
      {type === 'OPEN_ENDED' && <OpenEndedInputs />}
      {type === 'RADIO_SELECT' && <RadioSelectInputs />}
      {type === 'PHOTO_UPLOAD' && <PhotoUploadInputs />}
    </MoonstarFormIteratorEntry>
  );
}

function TaskInputs() {
  return null;
}

function OpenEndedInputs() {
  return <BooleanInput source="required" defaultValue={true} />;
}

function RadioSelectInputs() {
  return (
    <>
      <BooleanInput source="required" defaultValue={true} />
      <ArrayInput source="options" validate={required()}>
        <MoonstarFormIterator addButton={<AddRadioSelectOptionButton />} dense>
          <TextInput source="text" validate={required()} />
        </MoonstarFormIterator>
      </ArrayInput>
    </>
  );
}

function AddRadioSelectOptionButton() {
  const { add } = useSimpleFormIterator();
  const translate = useTranslate();

  return (
    <Button type="button" variant="outline" onClick={() => add({ text: '' })}>
      <Plus />
      {translate('moonstar.checklists.tasks.addOption')}
    </Button>
  );
}

function PhotoUploadInputs() {
  return <BooleanInput source="required" defaultValue={true} />;
}
